<template>
  <div class="d-flex flex-column justify-center">
    <OneLineCell
      v-if="hasFirstLine"
      :text="firstLine"
      :text-class="firstLineClass"
      :text-style="firstLineStyle"
    />

    <div style="min-height: 27px;">
      <OneLineCell
        :text="secondLine"
        :text-class="secondLineClass"
        :text-style="secondLineStyle"
        :use-flex-layout="!isBadge"
      />
    </div>
  </div>
</template>

<script>
import OneLineCell from './OneLineCell.vue';

export default {
  name: 'TwoLineCell',
  components: {
    OneLineCell,
  },
  props: {
    firstLine: { type: [String, Number], default: '' },
    secondLine: { type: [String, Number], default: '' },
    firstLineClass: { type: [String, Array, Object], default: '' },
    secondLineClass: { type: [String, Array, Object], default: '' },
    firstLineStyle: { type: [String, Object], default: '' },
    secondLineStyle: { type: [String, Object], default: '' },
    isBadge: { type: Boolean, default: false },
  },
  computed: {
    hasFirstLine() {
      if (this.firstLine === null || this.firstLine === undefined) {
        return false;
      }

      return String(this.firstLine).trim().length > 0;
    },
  },
};
</script>
